import styled from '@mui/system/styled';
export const AssetsMainCnt = styled('div')(({ theme }) => ({
  padding: '0px 25px 0 25px',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    padding: '0px 10px 0 10px',
  },
}));
